import { defineMessages } from 'react-intl';

export default defineMessages({
    AddressLine1: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Address Line 1',
        defaultMessage: 'Address Line 1',
    },
    AddressLine2: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Address Line 2',
        defaultMessage: 'Address Line 2',
    },
    AddressLine3: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Address Line 3',
        defaultMessage: 'Address Line 3',
    },
    City: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.City',
        defaultMessage: 'City',
    },
    PostalCode: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.ZIP Code',
        defaultMessage: 'ZIP Code',
    },
    State: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.State',
        defaultMessage: 'State',
    },
    saveFailedMsg: {
        id: 'twia.commercial.buildingAdditionalInterest.Save failed, please try again',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'twia.commercial.buildingAdditionalInterest.Can\'t Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    nonStandardizedMessage: {
        id: 'twia.commercial.buildingAdditionalInterest.The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.',
        defaultMessage: 'The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.',
    },
    standardizedMessage: {
        id: 'twia.commercial.buildingAdditionalInterest.The address you entered has been updated to follow USPS standards.',
        defaultMessage: 'The address you entered has been updated to follow USPS standards.',
    },
    standardizeAddressDetails: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.standardizeAddressDetails',
        defaultMessage: 'Standardize Address Details',
    },
    ZIPCodeValidationMessage: {
        id: 'twia.commercial.buildingAdditionalInterest.Must be a valid postal code',
        defaultMessage: 'Must be a valid Zip Code/Postal Code.',
    },
    EmailValidationMessage: {
        id: 'twia.commercial.buildingAdditionalInterest.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    Required: {
        id: 'twia.commercial.buildingAdditionalInterest.This is a required field',
        defaultMessage: 'This is a required field.',
    },
    PhoneValidationMessage: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Phone',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    pleaseChoose: {
        id: 'twia.commercial.buildingAdditionalInterest.contacts.policyroles.Please Choose',
        defaultMessage: '-- Choose State --', // DE16324
    },
    cedexBureauMessage: {
        id: 'twia.commercial.buildingAdditionalInterest.Value must be between 0 and 2 characters',
        defaultMessage: 'Value must be between 0 and 2 characters',
    },

});
